















































































import uuid from 'uuid/v1';
import { mapActions } from 'vuex';
import FieldBase from '@/components/field/Base.vue';
import InfoBox from '@/components/InfoBox.vue';
import PropsTableMini from '@/components/PropsTableMini.vue';
import {
  GridColumn,
  GridTable,
} from '@/components/grid';

export default {
  props: {
    value: Array,
    resourceKey: String,
    resources: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      shape: () => ({
        properties: [],
        [this.resourceKey]: {
          id: uuid(),
        },
      }),
    };
  },
  methods: {
    ...mapActions('vendor', ['createResource']),
    createResourceDialog() {
      const self = this;
      this.$store.commit('dialog/CREATE', {
        compact: true,
        component: {
          mounted() {
            // remove focus from dialog buttons
            setTimeout(() => {
              this.$el.querySelector('input').focus();
            }, 100);
          },
          data: () => ({
            message: '',
            resourceName: '',
          }),
          methods: {
            create() {
              if (!this.resourceName.trim()) {
                this.message = `Please enter a ${self.resourceKey} name`;
                this.$el.querySelector('input').focus();
                return;
              }

              this.$store.commit('loader/ADD', {
                title: `Creating ${self.resourceKey}`,
                promise: self
                  .createResource({
                    type: self.resourceKey,
                    name: this.resourceName,
                  })
                  .then((vendor: any) => {
                    // close dialog (assuming this is the only one open)
                    const { dialogs, REMOVE } = this.$parent;
                    REMOVE(dialogs[0].id);
                  }),
              });
            },
          },
          template: `
            <div style="width: 260px; padding: 0;">
              <div>
                <input
                  v-model="resourceName"
                  @keyup="message = ''"
                  @keyup.enter="create"
                  placeholder="Name"
                  aria-label="Name" />
              </div>
              <transition name="transition fade-down">
                <p class="error" v-if="message">{{ message }}</p>
              </transition>
            </div>
          `,
        } as IView,
        buttons: [
          {
            text: `Create ${self.resourceKey}`,
            click: (dialog: any) => dialog.component[0].create(),
          },
          {
            text: 'Close',
            click: (dialog: any) => dialog.close(),
          },
        ],
      });
    },
    selectLastRowDropdown() {
      setTimeout(() => {
        // a little long winded just incase timer is too fast for device processor
        const dropdownSelector = '[class*="Dropdown_dropdown_"]';
        const dropdown = this.$refs.resourceDropdown;
        dropdown && dropdown.$el.querySelector(dropdownSelector).click();
      }, 100);
    },
    remove(rowIndex: number) {
      this.$emit('input', [
        ...this.value.slice(0, rowIndex),
        ...this.value.slice(rowIndex + 1),
      ]);
    },
    view(id: string) {
      const resourceKey = this.resourceKey;
      this.$router.push({
        name: resourceKey,
        params: {
          [resourceKey + 'Id']: id,
        },
      });
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      },
    },
    resourceList() {
      return (this.resources || [])
        .reduce((all: any, resource: any) => {
          all[resource.id] = resource.name;
          return all;
        }, {});
    },
    resourcePlural() {
      return this.resourceKey + 's';
    },
  },
  components: {
    FieldBase,
    GridColumn,
    GridTable,
    InfoBox,
    PropsTableMini,
  },
} as IView;
